import {Inject, Injectable, signal} from '@angular/core';
import {Kunde} from "../classes/kunde";
import {HttpClient} from "@angular/common/http";
import {Environment} from "../classes/environment";
import { extractTenantFromLocation } from "../core/tenant.util";

@Injectable({ providedIn: 'root' })
export class TenantContextService {
  private tenant = signal<string>('');
  private kunde = signal<Kunde | null>(null);


  constructor(private http: HttpClient, @Inject('environment') private environment: Environment, @Inject('LOCALSTORAGE') private storage: Storage) {}

  async init(): Promise<void> {
    // Wenn initApp den Kontext bereits direkt nach environment.json geladen hat,
    // vermeiden wir eine Doppelladung:
    const preloaded = this.storage.getItem('customerContextPreloaded') === '1';

    const context = extractTenantFromLocation();
    if (!context) {
      console.error('Kein Tenant aus der Subdomain ermittelt, Kontext-Initialisierung abgebrochen');
      return;
    }

    this.tenant.set(context);

    if (preloaded) { // bereits geladen → nur Signale/LocalStorage konsistent halten
      return;
    }

    try {
      const kunde = await this.http
        .get<Kunde>(this.environment.backendUrl + `kunde/${context}`)
        .toPromise();
      if (kunde) {
        this.tenant.set(kunde.kundeId);
        this.kunde.set(kunde);
        this.storage.setItem('tenantContext', kunde.kundeId);
      }
    } catch (err) {
      console.error('Ungültiger Tenant', err);
    }
  }

  getTenant() {
    return this.tenant.asReadonly();
  }

  getKunde() {
    return this.kunde.asReadonly();
  }

}
